import { Box, Group, Text } from '@mantine/core';

/** The brand lockup: mark, `RGS` in the display face, `CONFIG HUB` eyebrow. */
export const Logo = () => (
    <Group gap={11} wrap="nowrap" align="center" aria-label="RGS Config Hub">
        <img src="/logo-mark.svg" alt="" width={30} height={30} aria-hidden />
        <Box>
            <Text ff="heading" fz={20} lh={1} style={{ letterSpacing: '0.04em' }}>RGS</Text>
            <Text fz={9.5} c="dimmed" mt={3} style={{ letterSpacing: '0.2em' }}>CONFIG HUB</Text>
        </Box>
    </Group>
);
